// external libs
import { Box } from '@material-ui/core'

// components
import SubChecklistItem from './SubChecklistItem'

// types
import type { SubChecklist } from '../../../services/um/useChecklist'

export interface SubChecklistListProps {
    topicID: number
    parentID: number
    subChecklistList: SubChecklist[]
    onChange?: () => void
}

function SubChecklistList(props: SubChecklistListProps) {
    const { topicID, parentID, subChecklistList, onChange } = props

    return (
        <Box display="flex" flexDirection="column" pl={10} style={{ gap: 16 }}>
            {subChecklistList?.map((subChecklist) => (
                <SubChecklistItem
                    key={subChecklist.checklistID}
                    topicID={topicID}
                    parentID={parentID}
                    subChecklist={subChecklist}
                    onChange={onChange}
                />
            ))}
        </Box>
    )
}

export default SubChecklistList
